import React from 'react';
import { Box } from '@mui/material';
import { gray100 } from '../../../constants/colors';
import ForgetPasswordCard from '../../uiParts/card/ForgetPasswordCard';
import Header from '../../uiParts/menu/Header';
import MetaTitle from '../../utils/MetaTitle';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FBFBFB',
  },
  container: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px 16px',
    boxSizing: 'border-box',
  },
  header: {
    color: 'white',
    textAlign: 'left',
    backgroundColor: gray100,
    width: '100vw',
    height: '64px',
    '@media (max-width: 600px)': {
      width: '100%',
      height: '48px',
    },
  },
};

const ForgetPassword: React.FC = () => {
  return (
    <>
      <MetaTitle />
      <Box sx={styles.page}>
        <Header />
        <Box sx={styles.container}>
          <ForgetPasswordCard />
        </Box>
      </Box>
    </>
  );
};

export default ForgetPassword;
